import { isEqual } from 'lodash'
import { SchemaFieldModel } from '@/models/schema-field.model'
import { confirmBrowserQuit, logger } from '@/helpers'
import translations from '@/translations/en'

// Singleton
export default class SchemaChangeDetector {
    constructor() {
        if (!!SchemaChangeDetector.instance) {
            return SchemaChangeDetector.instance
        }

        SchemaChangeDetector.instance = this

        this.lastSavedKeys = []
        this.lastSavedFields = {}
        this.registeredChanges = {}

        return this
    }

    set lastSavedUsedKeys(keys) {
        this.lastSavedKeys = [...keys]
    }

    set lastSavedField(field) {
        if (this.lastSavedFields.hasOwnProperty(field.key)) {
            logger('🔋 BREAK setLastSavedFields', 'DEV')
            return
        }

        Object.assign(this.lastSavedFields, {
            [field.key]: new SchemaFieldModel({
                ...field,
                subForm: { ...field.subForm }
            })
        })
    }

    get areChangesUnsaved() {
        let result = false

        for (const value of Object.values(this.registeredChanges)) {
            if (value) {
                result = true
                break
            }
        }

        return result
    }

    registerChange({ name, bool }) {
        this.registeredChanges[name] = bool
        logger(`🔋 this.registeredChanges ${this.registeredChanges}`, 'DEV')

        if (this.areChangesUnsaved) {
            confirmBrowserQuit(translations['UNSAVED_CHANGES_MESSAGE'])
        } else {
            confirmBrowserQuit('', true)
        }
    }

    checkUsedKeys(newUsedKeys) {
        let hasChanged = false

        if (newUsedKeys.length !== this.lastSavedKeys.length) {
            hasChanged = true
        } else {
            for (let key of this.lastSavedKeys) {
                if (newUsedKeys.indexOf(key) === -1) {
                    hasChanged = true
                    break
                }
            }
        }

        this.registerChange({ name: 'usedKeys', bool: hasChanged })

        logger(`🔋 hasChanged - USED_KEYS ${hasChanged}`, 'DEV')

        return hasChanged
    }

    checkFieldData(newData) {
        if (!(newData instanceof SchemaFieldModel)) {
            return console.error(
                'In file: schema-change-detector.js\nnewData is not instance of SchemaFieldModel'
            )
        }

        const hasChanged = !isEqual(newData, this.lastSavedFields[newData.key])

        this.registerChange({ name: newData.key, bool: hasChanged })

        logger(`🔋 hasChanged - FIELD ${newData.key} ${hasChanged}`, 'DEV')
        return hasChanged
    }

    resetLastSavedFields() {
        this.lastSavedFields = {}
    }

    resetRegisteredChanges() {
        this.registeredChanges = {}
        confirmBrowserQuit('', true)
    }
}



// WEBPACK FOOTER //
// ./src/plugins/schema-change-detector.js